const isValidNationalId = (id = '') => {
	if (id.length < 9) {
		id = id.padStart(9, '0');
	}

	if (id.length !== 9 || isNaN(id) || id === '000000000') {
		return false;
	}

	let sum = 0; let
		incrementNumber;
	for (const i in id) {
		incrementNumber = Number(id[i]) * ((i % 2) + 1);
		sum += (incrementNumber > 9) ? incrementNumber - 9 : incrementNumber;
	}

	return (sum % 10 === 0);
};

export default isValidNationalId;
